module.exports = __webpack_public_path__ + "img/frame (211).7b2c2ca4.jpg";